module.exports = __webpack_public_path__ + "media/components/country-flag/static/sk-f06788a50a254a9317632157670e3e55.svg";